import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './SearchBar.scss';

function SearchBar({ value, onSearch }) {
  const { t } = useTranslation();

  const handleChange = (e) => {
    onSearch(e.target.value);
  };

  const handleClear = () => {
    onSearch('');
  };

  return (
    <InputGroup className="search-bar-container">
      <InputGroup.Text>
        <FontAwesomeIcon icon={faSearch} />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder={t('searchBar.placeholder')}
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button 
          type="button"
          className="search-clear-button"
          onClick={handleClear}
          aria-label="Cancella ricerca"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </InputGroup>
  );
}

export default SearchBar; 